import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { font } from "../constants/font";
import Typography from "./Typography";

const TabContainer = styled.div`
  position: relative;
  display: flex;
  // background: ${(props) => props.theme.liBgColor};
  width: 100%; /* Updated total width */
  height: 56px; /* Updated height */
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  border: 1px solid #e3e4e7;
`;

const Tab = styled.div`
  position: relative;
  padding: 10px 15px;
  cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};
  width: 253px; /* Updated width for each tab */
  border-radius: ${(props) => (props.active ? "6px" : "unset")};
  text-align: center;
  font: ${font.mediumMini};
  text-transform: capitalize;
  color: ${(props) => props.theme.tabTextColor};
  z-index: 1;
  transition: background-color 0.3s linear, transform 0.3s linear;
  &:hover {
    transform: scale(1.02);
    color: ${(props) => props.theme.blackColor};
  }
  @media screen and (max-width: 767px) {
    padding: 4px 10px;
  }
`;

const DiscountLabel = styled.div`
  background: transparent linear-gradient(287deg, #775afd 0%, #ac67fd 100%) 0%
    0% no-repeat padding-box;
  border-radius: 13px;
  // position: absolute;
  // top: 7px;
  // right: 36px;
  padding: 4px 8px;
  color: #fff;
  font: ${font.normal_600_11};
`;

const TabIndicator = styled.div`
  position: absolute;
  border: 1px solid #a5e0f5;
  bottom: 4px;
  left: 4px;
  height: 46px; /* Adjusted height to fit within 48px */
  z-index: 0;
  width: 245px; /* Updated width for each tab */
  background-color: ${(props) => props.theme.polarColor};
  box-shadow: ${(props) => `0px 1px 3px ${props.theme.boxShadowBgColor}`};
  border-radius: 12px;
  background: #ddf6ff 0% 0% no-repeat padding-box;
  transform: ${(props) => `translateX(${props.activeTab * 242}px)`}; /* Updated calculation */
  transition: transform 0.3s linear;

  @media screen and (max-width: 767px) {
    width: 50%;
    left: ${(props) => (props.activeTab === 0 ? "4px" : "-4px")};
    transform: ${(props) => `translateX(${props.activeTab * 100}%)`};
  }
`;

const CycleContainer = styled.div`  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const TogglePriceTab = ({ tabs, activeTab, onTabChange, disableTab, save }) => {
  return (
    <TabContainer>
      {tabs.map((tab, index) => {
        const isDisabled = disableTab === index;

        return (
          <Tab
            key={tab.label}
            active={index === activeTab}
            isDisabled={isDisabled}
            onClick={() => {
              if (!isDisabled) onTabChange(index);
            }}
          >
            <CycleContainer>
              <Typography
                content={tab.label}
                font={
                  index === activeTab
                    ? font.normal_600_16
                    : font.normal_medium_16
                }
                color={"#313345"}
                cursor={isDisabled ? "not-allowed" : "pointer"}
              />
              {index === 1 && save && <DiscountLabel>{save}% off</DiscountLabel>}
            </CycleContainer>
          </Tab>
        );
      })}
      <TabIndicator activeTab={activeTab} />
    </TabContainer>
  );
};


TogglePriceTab.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
  disableTab: PropTypes.bool,
  save: PropTypes.number
};

export default TogglePriceTab;

